import { styled } from "goober";
import { PressButton } from "../../PressButton";

const TabContainer = styled("div")`
  display: flex;
  align-items: center;
  align-self: flex-start;
  height: 32px;
  background: var(--alpha4);
  border-radius: 8px;
  padding: 0 2px;
  position: relative;
`;

const TabIndicator = styled("div")`
  position: absolute;
  height: 28px;
  border-radius: 6px;
  background: var(--surface-primary);
  box-shadow: var(--elevation-low);
  outline: 0.5px solid var(--border-alpha);
  transition: transform 0.15s ease;
  pointer-events: none;
`;

const Tab = styled(PressButton)`
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  padding: 0;
  background: transparent;
  font-family: inherit;
  font-weight: 450;
  font-size: 11px;
  color: var(--text-secondary);
  opacity: 0.5;
  position: relative;
  z-index: 1;
  &[data-active="true"] {
    color: var(--text-primary);
    opacity: 1;
  }
`;

export function ModeTabs<T extends string>({
  options,
  value,
  onChange,
}: {
  options: { value: T; label: string }[];
  value: T;
  onChange: (next: T) => void;
}) {
  const tabWidth = 116;
  const index = options.findIndex((o) => o.value === value);
  return (
    <TabContainer>
      <TabIndicator
        style={{
          width: tabWidth,
          transform: `translateX(${index * tabWidth}px)`,
        }}
      />
      {options.map((opt) => (
        <Tab
          key={opt.value}
          data-active={value === opt.value}
          onPress={() => onChange(opt.value)}
          style={{ width: tabWidth }}
        >
          {opt.label}
        </Tab>
      ))}
    </TabContainer>
  );
}
